<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Filtres
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0"
        >
          <label>Année</label>
          <v-select
            :value="yearValue"
            :options="yearOptions"
            class="w-100"
            @input="(val) => changeFilter(val, 'YEAR')"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0"
        >
          <label>Modèle</label>
          <v-select
            :value="modelValue"
            :options="modelOptions"
            class="w-100"
            @input="(val) => changeFilter(val, 'MODEL')"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex justify-content-end align-items-end"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline"
            class="btn-icon"
            @click="resetFilters"
          >
            Réinitialiser
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    yearOptions: {
      type: Array,
      required: true,
    },
    modelOptions: {
      type: Array,
      required: true,
    },
    yearValue: {
      type: Number,
      default: null,
    },
    modelValue: {
      type: Number,
      default: null,
    },
  },
  methods: {
    resetFilters() {
      this.$emit('update:yearValue', null)
      this.$emit('update:modelValue', null)
    },
    changeFilter(value, filter) {
      if (filter === 'YEAR') {
        this.$emit('update:yearValue', value)
      }
      if (filter === 'MODEL') {
        this.$emit('update:modelValue', value)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
